export const CACHE_ADD_SEARCH_RESULT = `CACHE_ADD_SEARCH_RESULT`
export const CACHE_CLEAR = `CACHE_CLEAR`
